// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"d304fc1d","34":"27c31314","98":"cc5b667e","130":"2505abe2","318":"5fc5e2fb","399":"ab274065","453":"c40cd72a","484":"e729a242","513":"0aa5f4e5","543":"5c8f34f8","569":"54758f1f","604":"8e95f910","787":"a69883f5","851":"c48a912c"}[chunkId] + ".chunk.js";
};